<div class="modal-header">
  <h4 class="modal-title">Add/Edit Announcement</h4>
  <button ngbAutofocus class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" ngbAutofocus>
  <myp-inline-loader [loading]="loading" height="200px" spinnerName="addEditAnnouncementLoader"></myp-inline-loader>
  @if (!loading) {
    <div>
      <myp-segmented-bar
        (selected)="preview = $event.id == 'preview' ? true : false"
        [options]="[
          {
            name: 'Edit',
            id: 'edit',
            selected: true,
          },
          {
            name: 'Preview',
            id: 'preview',
          },
        ]"
      ></myp-segmented-bar>
      @if (!preview) {
        <div class="form-group m-t-20">
          <label class="control-label" for="title">Title</label>
          <input type="text" name="title" id="title" [(ngModel)]="announcement.title" class="form-control" />
        </div>
        <div class="form-group m-t-20">
          <label class="control-label" for="string_id">String ID</label>
          <input type="text" name="string_id" id="string_id" [(ngModel)]="announcement.string_id" class="form-control" />
        </div>
        <div class="form-group m-t-20">
          <label class="control-label" for="description">Description</label>
          <span class="text-muted t-12 d-block m-b-5">Compose your HTML in an HTML editor an then paste it here.</span>
          <textarea type="text" name="description" id="description" style="height: 300px" [(ngModel)]="announcement.enDescription" class="form-control"></textarea>
        </div>
        <div class="form-group m-t-20">
          <label class="control-label" for="external_link">Date</label>
          <span class="text-muted t-12 d-block m-b-5">Choosing a date in the past will turn this announcement on immediately for everybody.</span>
          <div class="form-control pointer" mode="button" name="release_date" id="release_date" (click)="showDatePicker()">
            {{ date ? (date | date) : ("newdash.choose_date" | translate) }}
          </div>
        </div>
        <div class="form-group m-t-20">
          <label class="control-label" for="product">Only show to those who own...</label>
          <span class="text-muted t-12 d-block m-b-5">Search products below, and select the ones you want to limit this announcement to. If you don't select any, it will show to everyone.</span>
          <input class="form-control" name="product" [(ngModel)]="productQuery" />
        </div>
        @if (productQuery && productResults && productResults.length) {
          <div class="product-results m-b-30 trans-bg border-radius10 p-10">
            @for (product of productResults; track product) {
              <myp-list-item [title]="product.title" [subData]="[product.DTYPE]" [includeChevron]="false" [showImage]="false">
                <div class="button-content">
                  <fa-icon icon="plus" placement="left" [ngbTooltip]="'Select Product'" (click)="selectProduct(product)" class="action green circle-icon-btn m-r-10"></fa-icon>
                </div>
              </myp-list-item>
            }
            <button class="btn btn-primary" (click)="this.productQuery = ''; this.productResults = []">Done</button>
          </div>
        }
        <div class="m-y-20">
          <div class="list-tags">
            @for (stringId of selectedProductStringIds; track stringId) {
              <span class="list-tag-item">
                {{ stringId }}
                <fa-icon icon="times-circle" (click)="removeProduct(stringId)"></fa-icon>
              </span>
            }
          </div>
        </div>
        <div class="form-group row">
          <div class="col-12">
            <h4 class="section-header m-b-10">
              <myp-switch
                extraClasses="m-b-10"
                [active]="!userGroupsCollapsed"
                label="Only show to users in selected groups..."
                [labelToRight]="true"
                (toggle)="userGroupsCollapsed = !userGroupsCollapsed"
              ></myp-switch>
            </h4>
            @if (!userGroupsCollapsed) {
              <div class="m-b-20">Only users that have been assigned to a selected group will be see this announcement.</div>
            }
          </div>
          @if (!userGroupsCollapsed && loadingGroups) {
            <div class="d-flex">
              <fa-icon class="m-r-10" icon="spinner" [animation]="'spin'"></fa-icon>
              <span>Loading Groups...</span>
            </div>
          }
          @if (groups?.length && !userGroupsCollapsed) {
            @for (group of groups; track group) {
              <div class="col-lg-4 col-md-6">
                <myp-switch
                  extraClasses="m-b-10"
                  [active]="groupMap[group.id].selected"
                  [label]="group.description"
                  [labelToRight]="true"
                  (toggle)="groupMap[group.id].selected = !groupMap[group.id].selected"
                ></myp-switch>
              </div>
            }
          }
        </div>
        <hr />
        <div class="form-group m-t-20">
          <label class="control-label" for="description">Audience</label>
          <span class="text-muted t-12">Choose where this will display.</span>
          <div class="d-flex">
            <span class="radio-option" (click)="audience.web = !audience.web" [class.selected]="audience.web">
              @if (audience.web) {
                <fa-icon icon="check-circle"></fa-icon>
              }
              Web
            </span>
            <span class="radio-option" (click)="audience.mobile = !audience.mobile" [class.selected]="audience.mobile">
              @if (audience.mobile) {
                <fa-icon icon="check-circle"></fa-icon>
              }
              Mobile
            </span>
          </div>
        </div>
        <myp-switch
          extraClasses="m-b-10 m-t-20"
          [active]="announcement.members_only"
          [label]="'Only show to ' + env.studioOnePlusBrandName + ' Members.'"
          [labelToRight]="true"
          (toggle)="announcement.members_only = !announcement.members_only"
        ></myp-switch>
        <myp-switch extraClasses="m-b-10 m-t-20" [active]="announcement.dev" label="Only show in development." [labelToRight]="true" (toggle)="announcement.dev = !announcement.dev"></myp-switch>
      }
      @if (preview) {
        <div class="text-center m-t-20">
          @if (announcement.title) {
            <h2>{{ announcement.title }}</h2>
          }
          @if (pickerDateDate) {
            <span class="t-14 d-block m-b-10">{{ pickerDateDate | date: "MMM Do" }}</span>
          }
          <div [innerHTML]="announcement.enDescription ? (announcement.enDescription | safe: 'html') : 'No description entered yet...'"></div>
        </div>
      }
    </div>
  }
</div>
<div class="modal-footer">
  <button type="button" [disabled]="loading" class="btn btn-primary" (click)="submit()">
    <span>Submit</span>
  </button>
  <button type="button" class="btn btn-blank" (click)="activeModal.close('Close click')">{{ "general.close" | translate }}</button>
</div>
